import React from "react";
import { SzInput } from "@suezenv/react-theme-components";
import { FieldProps } from "react-jsonschema-form";

const SzInputForm: React.FC<FieldProps> = (props) => {
    const { schema, onChange, uiSchema, disabled, value } = props;

    return (
        <SzInput
            error={props.rawErrors?.length > 0}
            placeholder={uiSchema.placeholder}
            disabled={disabled}
            type={schema.type as any}
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />
    );
};

export default SzInputForm;
